import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useState } from "react";

export const ReportAppendixC = ({ data }) => {
  const [teacherWiseUsage] = useState(
    Object.values(data.teacher_wise_usage_report)
      .sort((a, b) => b.total_usage - a.total_usage)
      .slice(0, 50)
  );

  const columns = [
    { id: "sl_no", label: "Sl. No." },
    { id: "teacher_name", label: "Teacher Name" },
    { id: "school_name", label: "School Name" },
    { id: "total_usage", label: "Total Usage (Hours)" },
  ];

  return (
    <div className="report-appendixC-container">
      <Typography
        sx={{
          fontSize: "35px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "30px",
        }}
      >
        Appendix C: Teacher-wise Usage for Top 50 Teachers
      </Typography>
      <TableContainer component={Paper} className="table m-1 mt-4">
        <Table id="summary" className="mb-0">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.id}>{column.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {teacherWiseUsage.map((row, index) => {
              return (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row.teacher_name}</TableCell>
                  <TableCell>{row.school_name}</TableCell>
                  <TableCell>{Math.ceil(row.total_usage / 60)}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
